(() => {
  document.querySelectorAll('[data-ac-quiz]').forEach(root => {
    const cfgEl = root.querySelector('[data-config]');
    let cfg = {};
    try { cfg = JSON.parse((cfgEl?.textContent || '').trim()); } catch(e) { cfg = { steps: [] }; }

    const steps          = Array.isArray(cfg.steps)         ? cfg.steps         : [];
    const rules          = Array.isArray(cfg.rules)          ? cfg.rules          : [];
    const availableSizes = Array.isArray(cfg.availableSizes) ? cfg.availableSizes : [];
    const defaultGo      = cfg.defaultGo      || '/collections/alle-tvs';
    const distanceStepId = cfg.distanceStepId || 'kijkafstand';

    const elBar    = root.querySelector('[data-bar]');
    const elStep   = root.querySelector('[data-steptext]');
    const elQ      = root.querySelector('[data-question]');
    const elHelper = root.querySelector('[data-helper]');
    const elOpts   = root.querySelector('[data-options]');
    const elResult = root.querySelector('[data-result]');
    const btnBack  = root.querySelector('[data-back]');
    const btnNext  = root.querySelector('[data-next]');

    const state = { i: 0, answers: {} };

    const deg2rad = d => d * (Math.PI / 180);
    const aspectWidthFactor = 0.8716;

    function calcRecommendedInches(distM) {
      const aComfort = cfg.distanceSizing?.angleComfort ?? 30;
      const aCinema  = cfg.distanceSizing?.angleCinema  ?? 40;
      const di = distM * 39.3701;
      const dC = (2 * di * Math.tan(deg2rad(aComfort / 2))) / aspectWidthFactor;
      const dI = (2 * di * Math.tan(deg2rad(aCinema  / 2))) / aspectWidthFactor;
      return { min: Math.min(dC, dI), max: Math.max(dC, dI) };
    }

    function sizesInRange(minInch, maxInch) {
      return availableSizes.filter(s => s.inch >= Math.floor(minInch) && s.inch <= Math.ceil(maxInch));
    }

    const fmt1    = n => Number(n).toLocaleString('nl-NL', { maximumFractionDigits: 1 });
    const fmtInch = n => Math.round(n);

    function setProgress() {
      const total = steps.length || 1;
      const pct   = Math.round((state.i / total) * 100);
      if (elBar)  elBar.style.width  = `${Math.min(100, Math.max(0, pct))}%`;
      if (elStep) elStep.textContent = `Stap ${Math.min(state.i + 1, total)} van ${total}`;
    }

    const currentStep   = ()  => steps[state.i];
    const currentAnswer = id  => state.answers[id];
    const canGoNext     = ()  => { const s = currentStep(); if (!s) return false; const v = currentAnswer(s.id); return v !== undefined && v !== null && v !== ''; };

    function renderChoice(step) {
      elOpts.innerHTML = '';
      const selected = currentAnswer(step.id);
      (step.options || []).forEach(opt => {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'ac-quiz__opt'; b.dataset.value = opt.value;
        const t = document.createElement('span'); t.className = 'ac-quiz__optTitle'; t.textContent = opt.label;
        b.appendChild(t);
        if (opt.desc) { const d = document.createElement('div'); d.className = 'ac-quiz__optDesc'; d.textContent = opt.desc; b.appendChild(d); }
        if (selected === opt.value) b.classList.add('is-selected');
        b.addEventListener('click', () => {
          state.answers[step.id] = opt.value;
          [...elOpts.querySelectorAll('.ac-quiz__opt')].forEach(x => x.classList.remove('is-selected'));
          b.classList.add('is-selected');
          btnNext.disabled = false;
          elHelper.textContent = '';
        });
        elOpts.appendChild(b);
      });
    }

    function renderRange(step) {
      elOpts.innerHTML = '';
      const wrap = document.createElement('div'); wrap.className = 'ac-quiz__range';
      const row1 = document.createElement('div'); row1.className = 'ac-quiz__rangeRow';
      const range = document.createElement('input'); range.type='range'; range.min=step.min??1; range.max=step.max??5; range.step=step.step??0.1;
      const numWrap = document.createElement('div'); numWrap.className = 'ac-quiz__rangeVal';
      const num = document.createElement('input'); num.type='number'; num.min=range.min; num.max=range.max; num.step=range.step;
      const unit = document.createElement('span'); unit.textContent = step.unit || 'm';
      numWrap.appendChild(num); numWrap.appendChild(unit); row1.appendChild(numWrap);
      const row2 = document.createElement('div'); row2.className = 'ac-quiz__rangeRow'; row2.appendChild(range);
      wrap.appendChild(row1); wrap.appendChild(row2); elOpts.appendChild(wrap);

      const saved = currentAnswer(step.id);
      const initVal = (saved !== undefined && saved !== null && saved !== '') ? Number(saved) : Number(step.default ?? 2.5);
      range.value = initVal; num.value = initVal;

      function update(val) {
        const v = Math.min(Number(range.max), Math.max(Number(range.min), Number(val)));
        range.value = v; num.value = v; state.answers[step.id] = v;
        if (step.id === distanceStepId) {
          const rec   = calcRecommendedInches(v);
          const sizes = sizesInRange(rec.min, rec.max);
          elHelper.textContent = sizes.length
            ? `Aanbevolen: ${fmtInch(rec.min)}–${fmtInch(rec.max)} inch (${sizes.map(s => s.inch + '"').join(', ')})`
            : `Aanbevolen: ${fmtInch(rec.min)}–${fmtInch(rec.max)} inch`;
        }
        btnNext.disabled = false;
      }
      range.addEventListener('input', e => update(e.target.value));
      num.addEventListener('input',   e => update(e.target.value));
      update(initVal);
    }

    function render() {
      if (!steps.length) { elQ.textContent = 'Configuratie ontbreekt.'; elOpts.innerHTML = ''; btnBack.disabled = true; btnNext.disabled = true; return; }
      elResult.hidden = true;
      btnBack.disabled = (state.i === 0);
      btnNext.disabled = !canGoNext();
      setProgress();
      const step = currentStep();
      elQ.textContent = step.question || '';
      elHelper.textContent = '';
      if ((step.type || 'choice') === 'range') renderRange(step);
      else renderChoice(step);
    }

    function bestMatch() {
      let best = null, score = -1;
      for (const rule of rules) {
        const when = rule.when || {}, keys = Object.keys(when);
        if (!keys.length) continue;
        if (!keys.every(k => state.answers[k] === when[k])) continue;
        if (keys.length > score) { score = keys.length; best = rule; }
      }
      return best;
    }

    function buildFilterUrl() {
      const rule   = bestMatch();
      const budget = state.answers['budget'];
      const dist   = Number(state.answers[distanceStepId]);
      const params = new URLSearchParams();
      params.set('sort_by', 'best-selling');

      // Schermtechnologie
      if (rule?.techId) {
        params.set('filter.v.t.shopify.display-technology', `gid://shopify/TaxonomyValue/${rule.techId}`);
      }

      // Beeldformaat – alle maten in aanbevolen range
      if (dist && isFinite(dist)) {
        const rec   = calcRecommendedInches(dist);
        const sizes = sizesInRange(rec.min, rec.max);
        sizes.forEach(s => params.append('filter.p.m.custom.screen_sizes', s.label));
      }

      // Prijs
      if (budget === 'budget') {
        params.set('filter.v.price.lte', '500');
      } else if (budget === 'mid') {
        params.set('filter.v.price.gte', '500');
        params.set('filter.v.price.lte', '1000');
      } else if (budget === 'premium') {
        params.set('filter.v.price.gte', '1000');
      }

      return `${defaultGo}?${params.toString()}`;
    }

    function buildAdviceText() {
      const g = state.answers['gebruik'], l = state.answers['licht'], b = state.answers['budget'];
      const lines = [];
      if (g === 'gaming')    lines.push("Gaming → lage input lag en game-specifieke features.");
      if (g === 'films')     lines.push("Films & series → contrast en beeldkwaliteit staan centraal.");
      if (g === 'sport')     lines.push("Sport → vloeiende beweging en hoge helderheid.");
      if (g === 'allround')  lines.push("Allround → goede balans tussen beeld, geluid en prijs.");
      if (l === 'licht')     lines.push("Veel daglicht → helderheid en anti-reflectie zijn belangrijk.");
      if (l === 'donker')    lines.push("Donkere kamer → maximaal zwart, OLED is ideaal.");
      if (l === 'gemiddeld') lines.push("Gemiddeld licht → de meeste tv-types voldoen.");
      if (b === 'budget')    lines.push("Budget tot €500 → beste prijs/kwaliteit.");
      if (b === 'mid')       lines.push("Budget €500–€1000 → sterke allrounders.");
      if (b === 'premium')   lines.push("Budget €1000+ → topkwaliteit beeld en features.");
      return lines.join(' ');
    }

    function showResult() {
      const rule       = bestMatch();
      const filterUrl  = buildFilterUrl();
      const adviceText = buildAdviceText();
      const dist       = Number(state.answers[distanceStepId]);

      let sizeLine = '';
      if (dist && isFinite(dist)) {
        const rec   = calcRecommendedInches(dist);
        const sizes = sizesInRange(rec.min, rec.max);
        const str   = sizes.length ? sizes.map(s => s.inch + '"').join(', ') : `${fmtInch(rec.min)}–${fmtInch(rec.max)} inch`;
        sizeLine = `<p><strong>Aanbevolen maat (kijkafstand ${fmt1(dist)} m):</strong> ${str}</p>`;
      }

      const ctaLabel = rule?.techName
        ? `Bekijk ${rule.techName} tv's op jouw maat`
        : `Bekijk tv's op jouw maat`;

      elResult.innerHTML = `
        <h3>${cfg.resultTitle || 'Ons advies voor jou'}</h3>
        ${adviceText ? `<div class="ac-quiz__advice"><strong>Waarom deze selectie?</strong> ${adviceText}</div>` : ''}
        ${sizeLine}
        <p>${cfg.resultText || 'Op basis van je antwoorden hebben we een gefilterde selectie klaargezet.'}</p>
        <div class="ac-quiz__ctaRow">
          <a class="ac-quiz__cta ac-quiz__cta--primary" href="${filterUrl}">${ctaLabel}</a>
          <a class="ac-quiz__cta ac-quiz__cta--secondary" href="${defaultGo}">${cfg.ctaSecondary || "Bekijk alle tv's"}</a>
        </div>
        <div style="margin-top:10px;">
          <button type="button" class="ac-quiz__btn ac-quiz__btn--ghost" data-restart>Opnieuw starten</button>
        </div>
      `;
      elResult.hidden = false;
      elResult.querySelector('[data-restart]')?.addEventListener('click', () => {
        state.i = 0; state.answers = {}; render();
        if (elBar)  elBar.style.width = '0%';
        if (elStep) elStep.textContent = `Stap 1 van ${steps.length}`;
      });
      if (elBar)  elBar.style.width = '100%';
      if (elStep) elStep.textContent = 'Klaar';
    }

    btnBack.addEventListener('click', () => { if (state.i > 0) { state.i -= 1; render(); } });
    btnNext.addEventListener('click', () => { if (state.i < steps.length - 1) { state.i += 1; render(); } else showResult(); });

    render();
  });
})();